/* eslint-disable max-len */
var UI_CROSS_CIRCLE = {
  "default": 'M21.71,11.71,17.41,16l4.3,4.29a1,1,0,0,1-1.42,1.42L16,17.41l-4.29,4.3a1,1,0,0,1-1.42-1.42L14.59,16l-4.3-4.29a1,1,0,0,1,1.42-1.42L16,14.59l4.29-4.3a1,1,0,0,1,1.42,1.42ZM32,16A16,16,0,1,1,16,0,16,16,0,0,1,32,16Zm-2,0a14,14,0,1,0-4.1,9.9A14,14,0,0,0,30,16Z',
  globetrotter: 'M11 11L21 21M21 11L11 21M29.5 16C29.5 23.46 23.46 29.5 16 29.5C8.54 29.5 2.5 23.46 2.5 16C2.5 8.54 8.54 2.5 16 2.5C23.46 2.5 29.5 8.54 29.5 16Z'
};

export { UI_CROSS_CIRCLE };
//# sourceMappingURL=UI_CROSS_CIRCLE.js.map
